<template>

<v-app>
<v-main>
<v-container
    fluid
    style="padding-left: 25px; padding-right: 25px"
    v-if="results != null"
>
    <h2 style="margin-bottom: 15px">State by state restrictions on the times messages may be sent</h2>

    Various states have established restrictions on the times of day that you may send messages.  Although our database of these rules may be incomplete or inaccurate, below is our attempt to summarize the times of days that are free from restrictions.


    <v-row>
        <v-col>
            <m-edit-date
                label="Start Date"
                v-model="start_date"
                v-on:input="doUpdate"
                style="margin-top: 15px"
            />
        </v-col>
        <v-col
            style="max-width: 300px"
        >
            <v-select
                label="Primary Time Zone"
                v-model="time_zone"
                :items="$rc.commonTimeZonesWithCurrentTimeZone()"
                style="margin-top: 15px"
                v-on:change="doUpdate"
            />
        </v-col>
    </v-row>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"

        style="margin-bottom: 15px; margin-top: 15px;"
    >

    </v-data-table>

    <p>Taken into account are upcoming holidays and known state-by-state rules.  See below for details.</p>

    <h2>Upcoming Holidays {{start_date == today ? null : '( starting from '+start_date+' )'}}</h2>

    <v-data-table
        v-if="upcoming_holidays != null"
        :headers="upcoming_holidays_headers"
        :items="upcoming_holidays"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"

        style="margin-bottom: 15px; margin-top: 15px;"
    >

    </v-data-table>

    <p style="margin-bottom: 15px">Know of a holiday we have missed or see a mistake? <a href="mailto:notices@redchirp.com">Email us</a></p>

    <h2>Non-holiday rules by state</h2>

    <v-data-table
        v-if="state_time_of_day_rules != null"
        :headers="by_state_rule_headers"
        :items="state_time_of_day_rules.by_rule_results"
        :items-per-page="1000"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"

        style="margin-bottom: 15px; margin-top: 15px;"
    >

    </v-data-table>

    <p style="margin-bottom: 15px">Know of a rule we have missed or see a mistake? <a href="mailto:notices@redchirp.com">Email us</a></p>

    <h2>Disclaimer</h2>
    <p style="margin-top: 15px">For informational purposes only, may be inaccurate or incomplete.</p>
    <p>This is not legal advice. Consult an attorney if you have legal or compliance questions about your text marketing campaigns.</p>

</v-container>
</v-main>
</v-app>
</template>

<script>
const Time = require('@/js/time.js');

export default {
    data() {
        return {
            results: null,
            upcoming_holidays: null,
            state_time_of_day_rules: null,

            headers: [
                { text: 'Date', value: 'date' },
                { text: 'Day', value: 'dow_three_letter'},
                { text: 'Interval Free of Known Restrictions', 'value': 'window_pretty_print'},
            ],

            upcoming_holidays_headers: [
                { text: 'Date', value: 'date' },
                { text: 'Description', 'value': 'description'},
                { text: 'Observed By', 'value': 'pretty_observed_by'}
                
            ],

            by_state_rule_headers: [
                { text: 'Location', value: 'location' },
                { text: 'Days of Week', 'value': 'days_pretty_print'},
                { text: 'Allowed interval', 'value': 'interval'},
                { text: 'State Time Zone(s)', 'value': 'time_zones_pretty_print'}
            ],

            start_date: Time.getISODate(new Date().getTime()),
            today: Time.getISODate(new Date().getTime()),
            time_zone: this.$rc.currentTimeZone(),
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        doUpdate() {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/restricted-messaging-times/window-over-days',
            
                'params' : {
                        'count': 7,
                        'start_date': this.start_date,
                        'time_zone': this.time_zone,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                        this.upcoming_holidays = data.upcoming_holidays;
                        this.state_time_of_day_rules = data.state_time_of_day_rules;
                    },
            
                'on_error': 'Unable to complete API call',
            });
        }
    },
}
</script>

<style lang="scss" scoped>
</style>